import { useEffect, useState } from 'react'

// Detects if current user agent is MetaMask Mobile
function isMetaMaskMobile() {
  const userAgent = navigator.userAgent || navigator.vendor
  return userAgent.includes('MetaMask')
}

export function useIsMetaMaskMobile() {
  const [isMetaMask, setIsMetaMask] = useState(false)

  useEffect(() => {
    setIsMetaMask(isMetaMaskMobile())
  }, [])

  return isMetaMask
}
